import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut, Clock } from 'lucide-react';

const LoggedOutPage = () => {
    const navigate = useNavigate();

    const handleLoginAgain = () => {
        // Redirect to the app root which will trigger Cognito login
        window.location.href = '/';
    };

    return (
        <div className="min-h-screen bg-porcelain flex items-center justify-center p-4">
            <div className="max-w-md w-full">
                <div className="bg-white rounded-2xl shadow-xl p-8 text-center">
                    {/* Icon */}
                    <div className="mb-6 flex justify-center">
                        <div className="relative">
                            <div className="w-20 h-20 bg-spruce-100 rounded-full flex items-center justify-center">
                                <LogOut className="text-spruce-600" size={40} />
                            </div>
                            <div className="absolute -top-1 -right-1 w-8 h-8 bg-yellow-100 rounded-full flex items-center justify-center">
                                <Clock className="text-yellow-600" size={16} />
                            </div>
                        </div>
                    </div>

                    {/* Heading */}
                    <h1 className="text-2xl font-bold text-gray-900 mb-3">
                        Session Ended
                    </h1>

                    {/* Message */}
                    <p className="text-gray-600 mb-2">
                        You've been logged out due to inactivity.
                    </p>
                    <p className="text-sm text-gray-500 mb-8">
                        For your security, we automatically log you out after 15 minutes of inactivity.
                    </p>

                    {/* Login Button */}
                    <button
                        onClick={handleLoginAgain}
                        className="w-full bg-spruce-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-spruce-700 transition-colors shadow-md hover:shadow-lg transform hover:-translate-y-0.5 transition-all"
                    >
                        Log In Again
                    </button>

                    {/* Footer */}
                    <p className="text-xs text-gray-400 mt-6">
                        Need help? Contact your administrator
                    </p>
                </div>
            </div>
        </div>
    );
};

export default LoggedOutPage;